export default __webpack_public_path__ + "db809213b238c13621842f77a74c4dac.png";